<div class="admin_menu flex ">
    <div class="menu-form  ">
        <div class="col-12  ">
            <input pInputText placeholder="Label" [(ngModel)]="selectedMenuItem['label']">
        </div>
        <div class="col-12 ">
        <input pInputText placeholder="url" [(ngModel)]="selectedMenuItem['url']">
    </div>
        <div class="col-12  ">
        <p-dropdown  [options]="listMenu" [(ngModel)]="selectedParent" optionLabel="name"
                    [style]="{'width': '100%'}"
                    [filter]="true" (onFilter)="fillListItems($event)"
                    filterBy="label" [showClear]="true" placeholder="Select Parent">
            <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                    <div>{{ selectedOption.label }}</div>
                </div>
            </ng-template>
            <ng-template let-page pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <div>{{ page.label }}</div>
                </div>
            </ng-template>
        </p-dropdown>
    </div>
        <div class="col-12  ">
            <input pInputText placeholder="RouterLink" [(ngModel)]="selectedMenuItem['routerLink']">
        </div>
        <div class="col-12  ">
            <input pInputText placeholder="tooltip" [(ngModel)]="selectedMenuItem['tooltip']">
        </div>
        <div class="col-12  ">
            <input pInputText placeholder="Icon" [(ngModel)]="selectedMenuItem['icon']">
        </div>
        <div class="col-12  ">
            <p-checkbox [binary]="true" label="visible" [(ngModel)]="selectedMenuItem['visible']"></p-checkbox>
        </div>
        <div class="col-12 ">
            <p-checkbox [binary]="true" label="separator" [(ngModel)]="selectedMenuItem['separator']"></p-checkbox>
        </div>
        <div class=" col-12 text-center">
            <button *ngIf="selectedMenuItem.id == null" [disabled]="selectedMenuItem['label'] ==null || selectedMenuItem['label'].length<1"
                    class="button" style="width: 50%;" (click)="addNewMenuRow(tt);">
                <span i18n="@@Save">Save</span>
            </button>
            <div class="flex">
                <button *ngIf="selectedMenuItem.id!= null" [disabled]="selectedMenuItem['label'] ==null || selectedMenuItem['label'].length<1"
                        class="button" style="width: 50%;" (click)="editMenu();">
                    <span i18n="@@Edit">Edit</span>
                </button>
                <button *ngIf="selectedMenuItem.id!= null" [disabled]="selectedMenuItem['label'] ==null || selectedMenuItem['label'].length<1"
                        class="button" style="width: 50%;" (click)="cancelEditMenu();">
                    <span i18n="@@Cancel">Cancel</span>
                </button>
            </div>

        </div>
    </div>
    <div class="list ">
        <p-treeTable #tt [value]="treeTbl"  [tableStyle]="{'min-width':'50rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th>Label</th>
                    <th>URL</th>
                    <th style="width: 150px;" ></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode  let-rowData="rowData">
                <tr [ttRow]="rowNode">
                    <td>
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{ rowData.label }}
                    </td>
                    <td>
                        {{ rowData['routerLink'] != null ? rowData['routerLink'] : rowData['url'] }}</td>
                    <td >
                        <i *ngIf="rowNode['node']['children']==null" class="pi pi-trash cursor-pointer" (click)="removeMenuFromList(rowNode)"></i>
                        <i class="pi pi-pencil cursor-pointer" (click)="editMenuFromList(rowNode)"></i>
                    </td>
                </tr>
            </ng-template>
        </p-treeTable>
    </div>
</div>
